import AccessControlDialog from "@/components/call/access-controls/shared/dialog";
import { AccessControlOpenLockedGate } from "@EspaceParkQC/sdk-call-center";
import { toast } from "@EspaceParkQC/sdk-react";
import { Unlock } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function OpenLockedGate({ gateName }: { gateName: string }) {
  const { t } = useTranslation("main");

  function handleSubmit() {
    toast.loading(t("intercom.access-controls.open-locked-gate.submitting"));
  }

  function handleSuccess() {
    toast.success(t("intercom.access-controls.open-locked-gate.success"));
  }

  function handleError(error: unknown) {
    if (error instanceof Error) {
      toast.error(error.message);
    } else {
      toast.error(JSON.stringify(error));
    }
  }

  return (
    <AccessControlOpenLockedGate
      onGateError={handleError}
      onGateSuccess={handleSuccess}
      render={({ button, form }) => (
        <AccessControlDialog
          variant="danger"
          gateName={gateName}
          requireConfirmBeforeSubmit
          requireConfirmBeforeSubmitMessage={t("intercom.access-controls.open-locked-gate.confirm-before-submit", { gateName })}
          warningMessage={t("intercom.access-controls.open-locked-gate.confirm-before-submit", { gateName })}
          title={t("intercom.access-controls.open-locked-gate.title")}
          description={t("intercom.access-controls.open-locked-gate.description")}
          icon={<Unlock className="size-4" />}
          buttonProps={button}
          formProps={form}
          onSubmit={async () => handleSubmit()}
          formOnSubmit={async (value?: string | number) => {
            if (typeof value === "string") {
              await form.onSubmit(value);
            }
          }}
        />
      )}
    />
  );
}
